import { createSlice } from '@reduxjs/toolkit';

export const userRoleSlice = createSlice({
  name: 'user',
  initialState: {
    role: '', 
  },
  reducers: {
    setUserRole: (state, action) => {
      state.role = action.payload;
    },
  },
});

export const { setUserRole } = userRoleSlice.actions;

export default userRoleSlice.reducer;
